import { actionGenerator } from '../../../../packages/redux-utils';
import { ETopicActionTypes, ISetTopicPayload, TTopicActions } from './types';

export const setTopic: (payload: ISetTopicPayload) => TTopicActions = actionGenerator<
  ETopicActionTypes.SetTopic,
  ISetTopicPayload
>(ETopicActionTypes.SetTopic);
